import * as yup from 'yup';
import { routes } from '../../../routes/mainRoutes';

const getValidationMessage = lang => ({
  email: yup
    .string()
    .required(lang.validation.required)
    .email(lang.validation.email)
    .min(3, lang.validation.getMessageByStringLength(3, 254))
    .max(254, lang.validation.getMessageByStringLength(3, 254)),
  password: yup
    .string()
    .required(lang.validation.required)
    .min(8, lang.validation.passwordLength),
  getConfirmPassword: confirmingField =>
    yup
      .string()
      .required(lang.validation.required)
      .when(confirmingField, (confirmFieldParam, schema) => {
        return schema.test({
          test: curField =>
            !!confirmFieldParam && curField === confirmFieldParam,
          message: lang.authForm.notMatchPasswordsMessage,
        });
      }),
});

const validateAuthForm = lang => ({
  login: yup.object().shape({
    email: getValidationMessage(lang).email,
    password: getValidationMessage(lang).password,
  }),
  register: yup.object().shape({
    email: getValidationMessage(lang).email,
    password: getValidationMessage(lang).password,
    confirmPassword: getValidationMessage(lang).getConfirmPassword('password'),
  }),
  sendEmail: yup.object().shape({
    sendEmail: getValidationMessage(lang).email,
  }),
  newPassword: yup.object().shape({
    newPassword: getValidationMessage(lang).password,
    newConfirm: getValidationMessage(lang).getConfirmPassword('newPassword'),
  }),
});

export const getValidationSchema = ({ lang, url }) => {
  switch (url) {
    case routes.LOGIN:
      return validateAuthForm(lang).login;
    case routes.REGISTER:
      return validateAuthForm(lang).register;
    case routes.SEND_EMAIL:
      return validateAuthForm(lang).sendEmail;
    case routes.RESET_PASSWORD:
      return validateAuthForm(lang).newPassword;
    default:
      return null;
  }
};
